<template>
  <div class="send-nft-confirm-comp">
    <div class="img-box">
      <img src="@/assets/images/pictures/user_invite.png" />
    </div>
    <div class="text-box">
      {{ $t('receiveNtfc.userInvite.text', [info.email]) }}
    </div>
    <div class="button-row">
      <mv-button type="round-black" text="common.ok" @click="$emit('ok')" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MvButton from '@/components/common/button/MvButton.vue';

export default defineComponent({
  name: 'UserInviteComp',
  emits: ['ok'],
  props: {
    info: {
      default: {
        id: 0,
        type: '',
        email: '',
      },
    },
  },
  components: { MvButton },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.img-box {
  height: 160px;
  text-align: center;

  img {
    width: 152px;
    height: 100%;
  }
}

.text-box {
  padding: 24px 16px !important;
  border-radius: 10px !important;
  color: var(--typo-body, #6f6b7d);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  .email {
    display: contents;
    color: var(--typo-heading, #5d596c);
    font-weight: 600;
  }
}
</style>
